var EHDI = EHDI || Object.create(null);


EHDI.scene.GameScene = function() {
    EHDI.aka.Container.call(this);
  
   

}

EHDI.scene.GameScene.prototype = Object.create(EHDI.aka.Container.prototype);

EHDI.scene.GameScene.prototype.initProps = function() {
    this.isOver = false;
}

EHDI.scene.GameScene.prototype.initGraphics = function() {
    EHDI.GAME.gameScene = this;
    EHDI.scene.GameScene.timer = new EHDI.components.Timer();
        if(EHDI.GAME.constants.customTimeLimit) {
            EHDI.scene.GameScene.timer.timeLeft = EHDI.GAME.constants.customTimeLimit / 1000;
        } else {
            EHDI.scene.GameScene.timer.timeLeft = EHDI.GAME.constants.gametimelimit / 1000;
        }
        EHDI.scene.GameScene.timer.x =  280;
        EHDI.scene.GameScene.timer.y =  5;
    EHDI.GAME.pauseButton = new EHDI.components.pauseButton();

     this.closeBtn = new EHDI.displays.Button(EHDI.Assets.images["btn_close"], null, null, null,0.8);
      this.closeBtn.position.set(EHDI.GAME.sceneManager.getStageWidth() * 0.95, EHDI.GAME.sceneManager.getStageHeight() * 0.075);
      this.closeBtn.setOnClickFunction(function(){
        callFlexFunction()
      });
     

    var bg = new EHDI.aka.Sprite(EHDI.Assets.images["bugout_bg"]);
    this.addChild(bg);
    
    var overlay = new EHDI.aka.Sprite(EHDI.Assets.images["bugout_branch"]);
    overlay.anchor.set(0.5, 0);
    overlay.position.set(EHDI.screen.stageWidth * 0.5, 0);
    this.addChild(overlay);
    
    this.bugManager = new EHDI.components.BugManager();
    this.bugManager.position.set(EHDI.screen.stageWidth * 0.5 - this.bugManager.width * 0.5, EHDI.screen.stageHeight * 0.15);
    this.bugManager.globalPosX += EHDI.screen.stageWidth * 0.5 - this.bugManager.width * 0.5;
    this.bugManager.globalPosY += EHDI.screen.stageHeight * 0.15;
    this.addChild(this.bugManager);
    
    this.inputOverlay = new EHDI.aka.Sprite(EHDI.displays.TextureRectangle(0xFFFFFF, this.width, this.height));
    this.addChild(this.inputOverlay);
    this.inputOverlay.alpha = 0;
    
    var _wildBugCount = 3;
    var changeBug = function() {
        if(EHDI.GAME.gameScene.bugManager.lockInput)
            return; 
        _wildBugCount--;
        EHDI.GAME.gameScene.bugText.text = _wildBugCount + "x";
        if(_wildBugCount <= 0)
            EHDI.GAME.gameScene.wildBug.visible = false;
        
        EHDI.GAME.gameScene.bugManager.changeCurrentBug();
    }
    
    this.resetBugCount = function() {
        _wildBugCount = 3;
        EHDI.GAME.gameScene.bugText.text = _wildBugCount + "x";
        EHDI.GAME.gameScene.wildBug.visible = true;
    }
    
    this.wildBug = new EHDI.displays.Button(EHDI.Assets.images["bugout_wildbug_con"], null, null, null, 0.8);
    this.addChild(this.wildBug);
    this.wildBug.position.set(EHDI.screen.stageWidth * 0.85, EHDI.screen.stageHeight * 0.85);
    this.wildBug.setOnClickFunction(changeBug);
    
    this.bugIcon = new EHDI.aka.Sprite(EHDI.Assets.images["bugout_wildbug"]);
    this.bugIcon.anchor.set(0.5);
    this.wildBug.addChild(this.bugIcon);
    this.bugIcon.position.x -= this.wildBug.width * 0.15;
    
    this.bugText = new EHDI.aka.PixiText("3x", {
                "fontFamily": "proximanova-black",
                "align": "center",
                "fill": "#FFFFFF",
                "fontSize": 32
            });
    
    this.wildBug.addChild(this.bugText);
    this.bugText.anchor.set(0.5);
    this.bugText.position.x += this.wildBug.width * 0.1;
    
    EHDI.GAME.gameScene.scoreHolder = EHDI.components.ScoreManager(this);
    EHDI.GAME.gameScene.scoreHolder.setXY(10,5);
    this.addChild(EHDI.scene.GameScene.timer);
    this.addChild(EHDI.GAME.pauseButton);
    this.addChild(this.closeBtn);
}

EHDI.scene.GameScene.prototype.initListeners = function() {
    EHDI.GAME.soundManager.autoResumeToggle(false);
    this.gameOver = function()
    {
        if(this.isOver) {
            return;
        }

        var score = EHDI.GAME.gameScene.scoreHolder.getScore();

        var cache = EHDI.GAME.storageManager.getLocalInfo(EHDI.GAME.id);
        if(score > cache.highScore) {
            EHDI.GAME.storageManager.setLocalInfo(EHDI.GAME.id, cache);
            cache.highScore = score;
        }

        this.isOver = true;

        if(EHDI.GAME.constants.gameEndFunction) {
            EHDI.GAME.soundManager.autoResumeToggle(true);
            EHDI.GAME.pauseButton.endGame();
            EHDI.GAME.constants.gameEndFunction(EHDI.GAME.constants.gameName, EHDI.GAME.gameScene.scoreHolder.getScore());   
        } else {
            var star = 0;
            if(score > 0 && score < 750) {
                star = 1;
            } else if (score >= 750 && score < 1500) {
                star = 2;
            } else if (score >= 1500) {
                star = 3;
            }
     
            EHDI.GAME.soundManager.playSFX("score_points"); //error like sound
            EHDI.GAME.soundManager.autoResumeToggle(true);
            EHDI.GAME.pauseButton.endGame();
            EHDI.GAME.sceneManager.pushPopUp(new EHDI.popup.PostGamePopUp(star, score), {y : new EHDI.scene.TransitionParameter(-EHDI.GAME.sceneManager.getStageHeight(), EHDI.GAME.sceneManager.getStageHeight() * 0.5), duration : 0.25});
        }
        /*if(isOver)
            return;
        
        var score = EHDI.GAME.gameScene.scoreHolder.getScore();
        var star = 0;
        if(score > 0 && score < 500) {
            star = 1;
        } else if (score >= 500 && score < 1200) {
            star = 2;
        } else if (score >= 1200) {
            star = 3;
        }

        isOver = true;        
        EHDI.GAME.soundManager.playSFX("score_points"); //error like sound
        EHDI.GAME.soundManager.autoResumeToggle(true);
        EHDI.GAME.pauseButton.endGame();
        EHDI.GAME.sceneManager.pushPopUp(new EHDI.popup.PostGamePopUp(star, score), {y : new EHDI.scene.TransitionParameter(-EHDI.GAME.sceneManager.getStageHeight(), EHDI.GAME.sceneManager.getStageHeight() * 0.5), duration : 0.25});*/
    }
    
    EHDI.scene.GameScene.timer.onTimerDone = this.gameOver;

    this.interactive = true;
    this.inputOverlay.interactive = true;
    this.mousemove = function(e) {
        if(EHDI.GAME.pauseButton.isPaused || EHDI.GAME.pauseButton.isEndGame)
            return;
        this.bugManager.handleMovement(e.data.global.x / EHDI.screen.scale, e.data.global.y / EHDI.screen.scale);
    }
    
    this.inputOverlay.tap = function(e) {
        if(EHDI.GAME.pauseButton.isPaused || EHDI.GAME.pauseButton.isEndGame )
            return;
        EHDI.GAME.gameScene.bugManager.shootBug(e.data.global.x / EHDI.screen.scale, e.data.global.y / EHDI.screen.scale);
    }
    
    this.inputOverlay.click = function(e) {
        if(EHDI.GAME.pauseButton.isPaused || EHDI.GAME.pauseButton.isEndGame )
            return;
        EHDI.GAME.gameScene.bugManager.shootBug(e.data.global.x / EHDI.screen.scale, e.data.global.y / EHDI.screen.scale);
    }
    
}

EHDI.scene.GameScene.prototype.screenWillAppear = function() {
    this.initProps();
    this.initGraphics();
};

EHDI.scene.GameScene.prototype.screenDidAppear = function() { 
    var cache = EHDI.GAME.storageManager.getLocalInfo(EHDI.GAME.id);
    if(cache.isFirstTimePlay || EHDI.GAME.constants.htpShow)
    {    
        cache.isFirstTimePlay = false;   
        EHDI.GAME.storageManager.setLocalInfo(EHDI.GAME.id, cache);
        EHDI.GAME.pauseButton.isPaused = true;
        EHDI.GAME.sceneManager.pushPopUp(new EHDI.popup.PausePopUp(), {y : new EHDI.scene.TransitionParameter(-EHDI.GAME.sceneManager.getStageHeight(), EHDI.GAME.sceneManager.getStageHeight() * 0.5), duration : 0.25});
    }

    this.initListeners();
};


EHDI.scene.GameScene.prototype.killGraphics = function() {
    this.scoreHolder.dispose();
    this.scoreHolder = null;

    this.bugText.destroy();
    this.bugText = null;

    this.bugIcon.destroy();
    this.bugIcon = null;

    this.wildBug.destroy();
    this.wildBug = null;

    this.inputOverlay.destroy();
    this.inputOverlay = null;

    this.bugManager.dispose();
    this.bugManager.destroy();
    this.bugManager = null;

    if(this.closeBtn != null)
        {
            this.removeChild(this.closeBtn);
            this.closeBtn.destroy();
        }
      delete this.closeBtn;

    EHDI.scene.GameScene.timer.dispose();
    EHDI.scene.GameScene.timer.destroy();
    EHDI.scene.GameScene.timer = null;
        
    EHDI.GAME.pauseButton.destroy();
    EHDI.GAME.pauseButton = null;


    EHDI.GAME.gameScene = null;
}


EHDI.scene.GameScene.prototype.restart = function() {
    this.killGraphics();

    this.initProps();
    this.initGraphics();
    this.initListeners();
}

EHDI.scene.GameScene.prototype.dispose = function() {
    this.killGraphics();
}

EHDI.scene.GameScene.prototype.screenDidDisappear = function() {
    this.killGraphics();
}

